var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "No",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 16.603 16.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_85_1",
    "data-name": "Symbol 85 \\u2013 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_3",
    "data-name": "Uni\\xF3n 3",
    d: "M8.3,9.811,1.509,16.6,0,15.093,6.792,8.3,0,1.509,1.509,0,8.3,6.792,15.093,0,16.6,1.509,9.811,8.3,16.6,15.093l-1.51,1.51Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertClose);
export default __webpack_public_path__ + "static/media/alert-close.dafb5fb4b939d16e6c12fa1d981e2cd6.svg";
export { ForwardRef as ReactComponent };